import { computed } from 'vue';
import { activityDetailStore, xAxisKeyMap } from '@client/store/activityDetailStore';
import Definition from '@client/config/definition';
import unitHelper from '@client/helper/unit';
import { dealAttrDefine, IMPERIAL_UNITS, METRIC_UNITS } from './utils/common';
import { useActivityDetail } from '../../hooks/useActivityDetail';

export const xAxisKey = xAxisKeyMap['distance-polyline'];

export default function useDistancePolylineChart({ chartAttr, activeAttributes }) {
  const activityDetailStoreRef = activityDetailStore();
  const { unitType } = useActivityDetail();

  const sportType = computed(() => activityDetailStoreRef.sportType);
  const sportName = Definition.getSportNameByType(sportType.value);

  function xTickInfo(distance) {
    let textValue = unitHelper.distanceKM2mile(distance / 100 / 1000, 2, unitType.value);
    let textUnit = {
      [METRIC_UNITS]: 'km',
      [IMPERIAL_UNITS]: 'mi'
    }[unitType.value];

    // 泳池游泳
    if (['Pool_Swim'].includes(sportName.value)) {
      textValue = {
        [METRIC_UNITS]: (value) => {
          return value;
        },
        [IMPERIAL_UNITS]: unitHelper.distanceM2Yard
      }[unitType.value](distance / 100);

      textUnit = {
        [METRIC_UNITS]: 'm',
        [IMPERIAL_UNITS]: 'yard'
      }[unitType.value];
    }

    return {
      text: `${Number(textValue).toFixed(2)}${textUnit}`,
      value: distance
    };
  }

  const chartNames = computed(() => {
    return activeAttributes.value
      .filter((item) => {
        return !item.noYScale;
      })
      .map((item) => item.chartName);
  });

  // 处理过后的属性参数
  const attributes = computed(() => {
    const attrs = [];
    const subAttrs = [];

    // 功率与风阻的特殊逻辑
    let powerIndex = -1;
    let airPowerIndex = -1;

    activeAttributes.value.forEach((item, index) => {
      attrs.push(item);

      if (item.chartName === 'Power') {
        powerIndex = index;
      }
      if (item.chartName === 'Air_Power') {
        airPowerIndex = index;
      }

      if (!item.subCharts) {
        return;
      }

      item.subCharts.forEach((chartName) => {
        const chartConfig = chartAttr.value[chartName];
        if (!chartConfig) {
          return;
        }
        subAttrs.push({
          ...chartConfig,
          chartName
        });
      });
    });

    if (powerIndex >= 0 && airPowerIndex >= 0) {
      // 删除功率，并以功率为基础创建新的属性，绘制河流图
      attrs[powerIndex].chartType = 'drawPowerAndAirPowerChart';
      attrs[airPowerIndex].chartType = 'drawAirPowerChart';
    }

    return [].concat(attrs, dealAttrDefine(subAttrs));
  });

  return {
    xTickInfo,
    chartNames,
    attributes
  };
}
